module.exports = __webpack_public_path__ + "media/images/lp_v6_sec12_border-3819209ea95c842666319cfc71a57d76.svg";